import { Box, Group, SegmentedControl } from '@mantine/core'
import { IconColumns, IconTable } from '@tabler/icons-react'
import { useUIStore } from '../../../../stores/UIStore'
import Sparkles from '../../../../components/Sparkles/Sparkles'

const PrmLayoutChanger = () => {
    const prmLayout = useUIStore(s => s.prmLayout)
    const setPrmLayout = useUIStore(s => s.setPrmLayout)

    const handleChange = (value) => {
        setPrmLayout(value)
    }

    return (
        <Box mx={"auto"} >
            <Sparkles>
                <SegmentedControl
                    data={[
                        { label: <Group wrap='nowrap' gap={"xs"} px={4}> <IconColumns size={16} /> Colonnes </Group>, value: "column" },
                        { label: <Group wrap='nowrap' gap={"xs"} px={4}> <IconTable size={16} /> Tableau </Group>, value: "table" },
                    ]}
                    value={prmLayout}
                    onChange={handleChange}
                    size='md'
                />
            </Sparkles>
        </Box>
    )
}

export default PrmLayoutChanger